import type { DeleteCustomRoleMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteCustomRoleDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteCustomRole = createMutationHook({
  name: 'deleteCustomRole',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.customRole.customRoleDelete.mutationOptions({ onSuccess }),
  mapInput: (variables: { id: string }) => ({ id: variables.id }),
  invalidate: (trpc) => [trpc.frontend.role.getCustomRoles.queryKey()],
  // Maps the tRPC response (camelCase `affectedRows`) back into the Apollo
  // shape so call sites stay compatible across both branches.
  mapResponse: (result: {
    affectedRows: number;
  }): DeleteCustomRoleMutation => ({
    delete_custom_role: {
      __typename: 'custom_role_mutation_response',
      affected_rows: result.affectedRows,
    },
  }),
  graphqlDocument: DeleteCustomRoleDocument,
  graphqlVariables: (variables: { id: string }) => ({
    filter: {
      Id: { _eq: variables.id },
    },
  }),
  // Mirrors the eviction that used to live inline in `update/Page.tsx`.
  evictFields: ['custom_role'],
});
